export default "__VITE_ASSET__DMqAmP6u__"